import style from './SmallLoading.module.css';

import { TbLoader2 } from "react-icons/tb";

const SmallLoading = ({ text }) => {

    return (
        <div className={style.container} >
            <div className={style.loading}>
                <TbLoader2 className={style.spinner} />
            </div>
            <div className={style.textContainer} >
                <p>{text ? text : "CARREGANDO..."}</p>
            </div>
        </div>
    )

}

export default SmallLoading;